<div class="passengers-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="header-copy">
      <span class="header-eyebrow">Pasajeros del file</span>
      <h2>Información de pasajeros</h2>
      <p>Consulta datos personales, documentación y clasificación PAX/TC.</p>
    </div>

    <button
      mat-icon-button
      type="button"
      class="close-button"
      aria-label="Cerrar"
      (click)="closeDialogWindow()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="isLoading" class="loading-state">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="42"
    ></mat-progress-spinner>
    <div>
      <h3>Cargando pasajeros</h3>
      <p>Estamos preparando la información del itinerario.</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!isLoading && !hasData">
    <mat-icon>groups_off</mat-icon>
    <h3>No hay pasajeros para mostrar</h3>
    <p>
      El itinerario no tiene pasajeros registrados o no se encontraron detalles
      disponibles.
    </p>
  </div>

  <div class="dialog-content" *ngIf="!isLoading && hasData">
    <div class="summary-toolbar">
      <div class="summary-chip total">
        <span>Total</span>
        <strong>{{ totalPassengers }} / {{ expectedTotalPassengers }}</strong>
      </div>
      <div class="summary-chip">
        <span>PAX asignados</span>
        <strong>{{ paxCount }} / {{ expectedPaxQuantity }}</strong>
      </div>
      <div class="summary-chip tc">
        <span>TC asignados</span>
        <strong>{{ tcCount }} / {{ expectedTcQuantity }}</strong>
      </div>

      <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="search-field"
      >
        <mat-label>Buscar pasajero</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="search"
          autocomplete="off"
          placeholder="Nombre, documento, grupo, correo..."
          [ngModel]="searchValue"
          (ngModelChange)="applySearch($event)"
        />
        <button
          *ngIf="searchValue"
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Limpiar búsqueda"
          (click)="applySearch('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="table-container">
      <div class="filtered-empty" *ngIf="dataSource.filteredData.length === 0">
        <mat-icon>search_off</mat-icon>
        <span>No hay resultados para la búsqueda.</span>
      </div>

      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="Pax">
          <mat-header-cell
            class="headerStyle"
            *matHeaderCellDef
            sortActionDescription="Sort by number"
          >
            No.
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax; let i = index">
            {{ pax.Pax || i + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            F. Actualización
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ formatDateTime(pax?.pasajero?.updatedAt) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Nombre
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.firstName || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Apellido
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.lastName || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateOfPass">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            F. Exp. Pasaporte
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ formatDate(pax?.documentInfo?.passportExpiration) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="residesInPeru">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Reside en Perú
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            <span
              class="residence-badge"
              [class.is-resident]="pax?.documentInfo?.residesInPeru"
            >
              {{ pax?.documentInfo?.residesInPeru ? "Sí" : "No" }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="documentType">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Tipo documento
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ formatDocumentType(pax?.documentInfo?.documentType) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="documentNumber">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Número documento
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.documentInfo?.documentNumber || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateOfBirth">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            F. Nacimiento
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ formatDate(pax?.pasajero?.dateOfBirth) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="gender">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Género
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ formatGender(pax?.pasajero?.gender) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edad">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Edad
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.age || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="talla">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Talla
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.size || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="peso">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Peso
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.weight || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="altura">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Altura
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.height || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="grupo">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Grupo
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.grupo || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Correo
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.email || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Teléfono
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.phone || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="country">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            País
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.country || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="restriccionesAlimentarias">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Restr. alimentarias
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.restriccionesAlimentarias || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="alergias">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Alergias
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.alergias || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="condicionesMedicas">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Cond. Médicas
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            {{ pax?.pasajero?.condicionesMedicas || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isTC">
          <mat-header-cell class="headerStyle" *matHeaderCellDef>
            Tipo
          </mat-header-cell>
          <mat-cell class="bodyStyle" *matCellDef="let pax">
            <span
              *ngIf="pax?.pasajero?.isTC != null"
              [ngClass]="pax?.pasajero?.isTC ? 'badge-tc' : 'badge-pax'"
            >
              {{ pax?.pasajero?.isTC ? "TC" : "PAX" }}
            </span>
            <span *ngIf="pax?.pasajero?.isTC == null">N/A</span>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns"
          sticky
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="dialog-actions" *ngIf="!isLoading">
    <button
      mat-stroked-button
      class="buttonSecundary"
      (click)="closeDialogWindow()"
    >
      Cerrar
    </button>
  </div>
</div>
